function colorMatches(datasetColor, selectedColor) {
  if (!datasetColor) return false;
  return datasetColor.split('||').some((c) => c.trim() === selectedColor);
}

function filterGalleryByColor(gallery, color) {
  let firstVisibleMediaId = null;
  gallery.querySelectorAll('[data-media-id]').forEach((item) => {
    const show = colorMatches(item.dataset.color, color);
    item.style.display = show ? '' : 'none';
    if (show && !firstVisibleMediaId) firstVisibleMediaId = item.dataset.mediaId;
  });
  gallery.querySelectorAll('.thumbnail-list__item').forEach((item) => {
    const show = colorMatches(item.dataset.color, color);
    item.style.display = show ? '' : 'none';
  });
  const viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
  const thumbSlider = gallery.querySelector('slider-component[id^="GalleryThumbnails-"]');
  if (viewer && viewer.resetPages) viewer.resetPages();
  if (thumbSlider && thumbSlider.resetPages) thumbSlider.resetPages();
  if (firstVisibleMediaId && gallery.setActiveMedia) {
    gallery.setActiveMedia(firstVisibleMediaId, true);
  }
}

function getInitiallySelectedColor(section) {
  const checkedInput = section.querySelector(
    '.product-form__input--swatch input:checked, .product-form__input--pill input:checked'
  );
  return checkedInput ? checkedInput.value.trim() : null;
}

function applyInitialColorFilter() {
  document.querySelectorAll('product-info, [data-section]').forEach((section) => {
    const gallery = section.querySelector('media-gallery');
    if (!gallery) return;
    const initialColor = getInitiallySelectedColor(section);
    if (!initialColor) return;
    filterGalleryByColor(gallery, initialColor);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  applyInitialColorFilter();
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
    const target = event.data.target;
    const selectedColor = target.value ? target.value.trim() : '';
    if (!selectedColor) return;
    const section = target.closest('product-info') || target.closest('[data-section]');
    if (!section) return;
    const gallery = section.querySelector('media-gallery');
    if (!gallery) return;
    filterGalleryByColor(gallery, selectedColor);
  });
});